import { checkAndShimPicture, checkForWebp } from '../../_shared/feature-check';
checkAndShimPicture();
checkForWebp();
import { selectRebuildOptions } from '../../_shared/common';
import { loadAutocompleteAndClient } from '../../_shared/vendor/algolia';
import '../../_shared/search';
import '../../_shared/popups/lead_popup_post_requirements';

import '../../_shared/global-pass.css';
import '../../_shared/flexible-spaces';
import './home.css';

window.Page = {};
Page.baseUrl = $('#base_url').val();
Page.cloudFrontUrl = $('#cloudfront_url').val();

Page.filters = [];
Page.filters.capacity = 0;
Page.filters.resourceTypes = 'all';
Page.returnUrl = '';

$(function () {
    $('#capacity_select li').on('click', function () {
        Page.filters.capacity = $(this).attr('rel');
    });
});
requestAnimationFrame(() => {
    loadSearchAutocompleteMenu('search_bar');
});

window.change_option = function change_option(ipt) {
    var ipt_id = ipt.id;
    var ipts = ['private_office', 'desks', 'meeting_room', 'virtual_office'];
    for (var nv = 0; nv < ipts.length; nv++) {
        if (
            ipt_id != 'ipt_' + ipts[nv] &&
            $('#ipt_' + ipts[nv]).is(':checked')
        ) {
            $('#ipt_' + ipts[nv]).prop('checked', false);
        }
    }
};

window.search_option = function search_option() {
    var search = $('#search_bar').val().trim();
    var duration = $('#ipt_duration').val().trim();
    $('#search_error').hide();
    $('#duration_error').hide();
    $('#pax_error').hide();
    if (search == '') {
        $('#search_error').show();
    }
    if (duration == '') {
        $('#duration_error').show();
    }
};

$('#search_button').on('click', function (e) {
    e.preventDefault();

    Page.filters.resourceTypes = [];
    $.each($('input[name="resource_types"]:checked'), function () {
        Page.filters.resourceTypes.push($(this).val());
    });

    var searchPlace = $('#search_bar').val().trim();

    $('#search_error').hide();

    if (searchPlace == '') {
        $('#search_error').show();
        return;
    } else {
        let queryString =
            '?filter_meeting_room_capacity=' +
            Page.filters.capacity +
            '&filter_start_date=' +
            $('#start_date').val() +
            '&filter_resource_types=' +
            Page.filters.resourceTypes;

        Page.returnUrl = Page.returnUrl + queryString;
        console.log(Page.returnUrl);
        window.location.href = Page.returnUrl;
    }
});

/* Generate No. of Pax on client side on next animation frame */
requestAnimationFrame(() => {
    const select = document.querySelector('#capacity_select select');
    const options = document.createDocumentFragment();
    for (let i = 0; i <= 500; i++) {
        const opt = document.createElement('option');
        opt.value = i;
        opt.innerText = i;
        options.appendChild(opt);
    }
    select.appendChild(options);
    selectRebuildOptions($(select));
});

// Does not use header's auto complete menu, clicking on a suggestion should not navigate
async function loadSearchAutocompleteMenu(searchBoxInputId)
{
    const {autocomplete, client} = await loadAutocompleteAndClient();

    const spaces = client.initIndex($('#algolia_space_index').val());
    const cities = client.initIndex($('#algolia_city_index').val());
    const countries = client.initIndex($('#algolia_country_index').val());

    $('#' + searchBoxInputId).autocomplete(
        {
            debug: true,
            autoselect: true,
            templates: {
                dropdownMenu:
                    '<div class="aa-dataset-cities"></div>' +
                    '<div class="aa-dataset-spaces"></div>' +
                    '<div class="aa-dataset-countries"></div>'
            },
        },
        [
            {
                source: autocomplete.sources.hits(spaces, {hitsPerPage: 5, filters: ''}),
                displayKey: 'display_name',
                name: 'spaces',
                templates: {
                    suggestion: function (suggestion) {
                        if (suggestion.display_name == null) return null;
                        return (
                            '<span class="fa fa-buildingui"><span class="cw_font">' + suggestion._highlightResult.display_name.value + '</span></span>'
                        );
                    },
                },
            },
            {
                source: autocomplete.sources.hits(cities, {hitsPerPage: 4}),
                displayKey: 'display_name',
                name: 'cities',
                templates: {
                    suggestion: function (suggestion) {
                        return (
                            '<div>' +
                            '<span class="fa fa-map-markerui"><span class="cw_font">' + suggestion._highlightResult.display_name.value + '</span></span>' +
                            '</div>' +
                            '<div class="space_count">' +
                            '(<em>' + suggestion._highlightResult.total_spaces.value + '</em> spaces)' +
                            '</div>'
                        );
                    },
                },
            },
            {
                source: autocomplete.sources.hits(countries, {hitsPerPage: 2}),
                displayKey: 'display_name',
                name: 'countries',
                templates: {
                    suggestion: function (suggestion) {
                        return (
                            '<div>' +
                            '<span class="fa fa-globeui"><span class="cw_font">' + suggestion._highlightResult.display_name.value + '</span></span>' +
                            '</div>' +
                            '<div class="space_count">' +
                            '(<em>' + suggestion._highlightResult.total_spaces.value + '</em> spaces)' +
                            '</div>'
                        );
                    },
                },
            },
        ]
    ).on('autocomplete:selected', function (event, suggestion, dataset) {

        Page.filters.resourceTypes = [];
        $.each($('input[name="resource_types"]:checked'), function () {
            Page.filters.resourceTypes.push($(this).val());
        });
        let queryString = "?filter_meeting_room_capacity="+Page.filters.capacity +
            "&filter_start_date="+$('#start_date').val()+
            "&filter_resource_types=" + Page.filters.resourceTypes;

        if (dataset == 'spaces') {
            Page.returnUrl = Page.baseUrl +  suggestion.profile_page_url;
            // console.log(Page.returnUrl);
        } else if (dataset == 'cities') {
            Page.returnUrl = Page.baseUrl + suggestion.search_page_url + queryString;
            // console.log(Page.returnUrl);
        } else if (dataset == 'countries') {
            Page.returnUrl = Page.baseUrl +  suggestion.search_page_url + queryString;
            // console.log(Page.returnUrl);
        } else {
            console.log('Not Found');
        }
    });

    $(document).on('click', function () {
        $('.aa-dropdown-menu').hide();
    });
}